import { Component } from '@theme/component';

class DeluluCurrency extends Component {
  #abort;
  connectedCallback() {
    super.connectedCallback();
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    const details = () => this.querySelector('details');
    this.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) details().open = true; }, { signal });
    this.addEventListener('mouseleave', () => { if (!this.contains(document.activeElement)) details().open = false; }, { signal });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { details().open = false; details().querySelector('summary').focus(); }
    }, { signal });
    this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) details().open = false; }, { signal });
    document.addEventListener('click', (event) => { if (!this.contains(event.target)) details().open = false; }, { signal });
    this.addEventListener('submit', (event) => {
      // Hydrated header HTML can inherit a section-rendering URL as its return path.
      const returnTo = event.target.querySelector('input[name="return_to"]');
      const page = new URL(window.location.href);
      page.searchParams.delete('section_id');
      page.searchParams.delete('sections');
      if (returnTo) returnTo.value = page.pathname + page.search;
    }, { signal });
  }
  disconnectedCallback() { this.#abort?.abort(); super.disconnectedCallback(); }
}

class DeluluWelcome extends Component {
  #abort;
  #timer;
  #returnFocus;
  #previousOverflow;
  #key = 'delulu-welcome-dismissed-v1';
  connectedCallback() {
    super.connectedCallback();
    this.#abort = new AbortController();
    const { signal } = this.#abort;
    const dialog = this.querySelector('dialog');
    this.querySelector('.delulu-welcome__launch').addEventListener('click', () => this.#open(), { signal });
    this.querySelector('.delulu-welcome__hide').addEventListener('click', () => {
      this.querySelector('.delulu-welcome__tab').hidden = true; this.#remember();
    }, { signal });
    this.querySelector('.delulu-welcome__close').addEventListener('click', () => dialog.close(), { signal });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } }, { signal });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = this.#previousOverflow || '';
      this.#remember(); this.#returnFocus?.focus();
    }, { signal });
    document.addEventListener('click', (event) => { if (event.target.closest('[data-open-welcome]')) { event.preventDefault(); this.#open(); } }, { signal });
    let dismissed = false;
    try { dismissed = !!sessionStorage.getItem(this.#key); } catch { /* Forms remain usable without storage. */ }
    if (this.querySelector('[data-signup-success], [role="alert"]')) this.#open();
    else if (!dismissed && !this.hasAttribute('data-design-mode') && !this.hasAttribute('data-cart-page')) {
      this.#timer = setTimeout(() => {
        if (!document.querySelector('dialog[open]') && !document.activeElement?.matches('input, textarea, select')) this.#open();
      }, Number(this.dataset.delay) * 1000);
    }
  }
  #remember() { try { sessionStorage.setItem(this.#key, 'true'); } catch { /* Optional persistence. */ } }
  #open() {
    const dialog = this.querySelector('dialog');
    if (dialog.open) return;
    clearTimeout(this.#timer); this.#returnFocus = document.activeElement;
    this.#previousOverflow = document.documentElement.style.overflow;
    dialog.showModal(); document.documentElement.style.overflow = 'hidden';
  }
  disconnectedCallback() {
    clearTimeout(this.#timer); this.#abort?.abort();
    if (this.querySelector('dialog')?.open) document.documentElement.style.overflow = this.#previousOverflow || '';
    super.disconnectedCallback();
  }
}
if (!customElements.get('delulu-currency')) customElements.define('delulu-currency', DeluluCurrency);
if (!customElements.get('delulu-welcome')) customElements.define('delulu-welcome', DeluluWelcome);
